import * as React from 'react';
import { Field, WrappedFieldInputProps } from 'redux-form';
import { useIntl } from 'react-intl';
import { CheckboxOption, JRCFormCheckboxProps } from './JRCFormCheckbox.types';
import { CheckboxLabel, CheckboxOrToggle, DirectionContainer, FocusBackground } from './JRCFormCheckbox.style';
import JRCFormFieldRender from '../JRCFormFieldRender';
import { ChangeEvent } from 'react';
import { useControls } from '../ReduxFormControls';
import { JRCRadio } from '../../JRCInputCheckbox/components/JRCRadio';

const JRCFormCheckboxFieldRender = (props: JRCFormCheckboxProps, input: WrappedFieldInputProps) => {
    const reduxFormBoolean = props.options.length === 1 && props.reduxFormValueType === 'boolean';
    const isChecked = (input: WrappedFieldInputProps, option: CheckboxOption) =>
        input &&
        (reduxFormBoolean
            ? input.value
            : props.checkboxMode === 'radio'
            ? input.value === option.value
            : input.value.includes(option.value));
    let options = props.SortByChecked
        ? props.options.sort((a, b) => isChecked(input, b) - isChecked(input, a))
        : props.options;

    React.useEffect(() => {
        if (props.SortByChecked) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            options = input && props.options.sort((a, b) => isChecked(input, b) - isChecked(input, a));
        }
    }, [input && input.value]);

    return (
        <>
            <DirectionContainer direction={props.direction} variant={props.variant}>
                {options.map((option, index) => (
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    <CheckboxLabel
                        key={index}
                        direction={props.direction}
                        labelPosition={props.labelPosition}
                        variant={props.variant}
                        disabled={props.disabled || option.disabled}
                        checked={isChecked(input, option)}
                        backgroundOnHover={props.backgroundOnHover}
                        backgroundOnSelect={props.backgroundOnSelect}>
                        {props.checkboxMode === 'radio' ? (
                            <JRCRadio
                                name={props.name}
                                value={option.value}
                                disabled={props.disabled || option.disabled}
                                checked={option.value === input.value}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => input.onChange(e.target.value)}
                            />
                        ) : (
                            <CheckboxOrToggle
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                checkboxMode={props.checkboxMode}
                                name={props.name}
                                value={option.value}
                                disabled={props.disabled || option.disabled}
                                checked={isChecked(input, option)}
                                onChange={(event) => {
                                    if (reduxFormBoolean) {
                                        return input.onChange(event.target.checked);
                                    } else {
                                        const newValue = [...input.value];
                                        if (event.target.checked) {
                                            newValue.push(option.value);
                                        } else {
                                            newValue.splice(newValue.indexOf(option.value), 1);
                                        }
                                        return input.onChange(newValue);
                                    }
                                }}
                            />
                        )}
                        <FocusBackground variant={props.variant} />
                        {option.label}
                    </CheckboxLabel>
                ))}
            </DirectionContainer>
        </>
    );
};

/**
 * @deprecated use JRCInputCheckbox instead
 */
export const JRCFormCheckbox = (props: JRCFormCheckboxProps) => {
    const validate = useControls({
        intl: useIntl(),
        required: props.required,
    });
    return (
        <Field
            component={JRCFormFieldRender}
            renderInputFct={(input: WrappedFieldInputProps) => JRCFormCheckboxFieldRender(props, input)}
            labelIsLegend={true}
            validate={validate}
            htmlFor={props.name}
            {...props}
        />
    );
};

JRCFormCheckbox.defaultProps = {
    name: 'you-must-change-that',
    options: [],
    direction: 'column',
    labelPosition: 'before',
    checkboxMode: 'checkbox',
    variant: 'default',
    label: '',
    reduxFormValueType: 'array',
    backgroundOnHover: false,
    backgroundOnSelect: false,
    SortByChecked: false,
};
